import { __assign } from "tslib";
import isString from 'lodash/isString';
import partial from 'lodash/partial';
/**
 * Adds keyboard support and select functionality to a StandardMenu item
 */
export function itemWithOnSelect(item, onSelect) {
    return __assign(__assign({}, item), { onClick: function (e) {
            // I would use optional chaining here, but `npm run test` doesn't like it
            if (item.onClick) {
                item.onClick(e);
            }
            if (onSelect) {
                onSelect(item.value, item.label);
            }
        } });
}
/** For use with `mapDropdownItemsToIndexes` */
function buildIndexForDropdownGroupItem(index, previousGroupValue, groupItem, groupInnerIndex) {
    var _a;
    return groupItem.label && isString(groupItem.label)
        ? __assign(__assign({}, previousGroupValue), (_a = {}, _a[groupItem.label] = {
            index: index,
            innerIndex: groupInnerIndex,
            selected: groupItem.selected,
        }, _a)) : previousGroupValue;
}
/** For use with `mapDropdownItemsToIndexes` */
function buildIndexesForDropdownGroup(index, previousValue, item) {
    return __assign(__assign({}, previousValue), item.items.reduce(partial(buildIndexForDropdownGroupItem, index), {}));
}
/** For use with `mapDropdownItemsToIndexes` */
function buildIndexForDropdownOption(index, previousValue, item) {
    var _a;
    return __assign(__assign({}, previousValue), (_a = {}, _a[item.label] = {
        index: index,
        innerIndex: null,
        selected: item.selected,
    }, _a));
}
/**
 *  Because our StandardMenu is made up of `DropdownItem`s (which can be a `DropdownOption` or a `DropdownGroup`),
 * tracking what index is currently focused is difficult.
 *
 *  This function flattens a `DropdownItem[]` by mapping each item's label to the index that said item exists within
 * the menu's root (returned object's `index` value) and stores a separate index that indicates where it exists within
 * a DropdownGroup (return object's `innerIndex` value)
 *
 * If `innerIndex` is null, the item exists at the menu's root.
 */
export function mapDropdownItemsToIndexes(items) {
    return items.reduce(function (previousValue, item, index) {
        var isLabelValidString = item.label && isString(item.label);
        var isDropdownItemAGroup = !!item.items;
        if (isLabelValidString || isDropdownItemAGroup) {
            if (item.items) {
                return buildIndexesForDropdownGroup(index, previousValue, item);
            }
            else if (isString(item.label)) {
                return buildIndexForDropdownOption(index, previousValue, item);
            }
        }
        return previousValue;
    }, {});
}
//# sourceMappingURL=utils.js.map